module.exports = __webpack_public_path__ + "ci_teams.0de7c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_teams.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_teams.svg
// module chunks = main